import { clsx } from 'clsx';
import type { ButtonProps } from '@agentselly/ui';
import { Button } from '@agentselly/ui';

/**
 * Kleine Sekundaer-Aktion in Widgets: kanonischer `Button` in der Variante
 * `outline`, Groesse `sm`, mit dem App-Border-Token und Dark-Mode-Klassen.
 * Ohne `max-w-xs`, damit `w-full`-Aufrufer weiterhin voll ausbreiten.
 */
export interface ActionButtonProps extends ButtonProps {
  /** @deprecated Stattdessen `variant="primary"` verwenden. */
  primary?: boolean;
}

export function ActionButton({
  primary,
  variant,
  size = 'sm',
  className,
  ...rest
}: ActionButtonProps) {
  const resolved = variant ?? (primary ? 'primary' : 'outline');

  return (
    <Button
      {...rest}
      variant={resolved}
      size={size}
      className={clsx(
        'text-sm',
        resolved === 'outline' &&
          '!border-border text-slate-700 hover:!border-border hover:bg-slate-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700',
        resolved === 'primary' &&
          'dark:bg-primary-600 dark:hover:bg-primary-500',
        className,
      )}
    />
  );
}
